import { rutinInfos } from '../../_Common/Const/RutinInfo';
import notImplemented from '../../_Common/Components/notImplemented/notImplemented';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import { createListRutin } from '../../_Common/Components/ListRutin/ListRutin';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';

const MURutiner = {
  rtnMusikstycke: {
    component: getStandardRutin(rutinInfos.rtnMusikstycke, 'MUMusikstycke'),
  },
  rtnForfattare: {
    component: getStandardRutin(rutinInfos.rtnForfattare, 'MUForfattare'),
  },
  rtnNotarkiv: {
    component: getStandardRutin(rutinInfos.rtnNotarkiv, 'MUArkiv'),
  },
  rtnNoter: {
    component: getStandardRutin(rutinInfos.rtnNoter, 'MUArkivinformation'),
  },
  rtnFramforanden: {
    component: getStandardRutin(rutinInfos.rtnFramforanden, 'MUFramforande'),
  },
  rtnExportXML: {
    component: withAddStartedRoutine(rutinInfos.rtnExportXML)(
      createListRutin(
        'MUMusikstycke',
        [
          { attributeDef: 'PREFIX', caption: 'PREFIX' },
          { attributeDef: 'ID', caption: 'ID' },
          { attributeDef: 'TITEL', caption: 'Titel' },
          { attributeDef: 'ALT_TITEL', caption: 'Alternativ titel' },
          { attributeDef: 'TONS_MEL', caption: 'Tonsättare' },
          { attributeDef: 'ARR', caption: 'Arrangör' },
          { attributeDef: 'TEXT_F', caption: 'Textförfattare' },
          { attributeDef: 'T_BEARB', caption: 'Övers./Textb' },
          { attributeDef: 'KOMPAR', caption: 'Kompositionsår' },
          { attributeDef: 'SPR', caption: 'Språk' },
          { attributeDef: 'OMFATTN', caption: 'Omfattning' },
          { attributeDef: 'STTN', caption: 'Vokalbesättning' },
          { attributeDef: 'INSTRBES', caption: 'Instrumentbesättning' },
          { attributeDef: 'OVRSTTN', caption: 'Övrig sättningsinformation' },
          { attributeDef: 'BRUK', caption: 'Tillfälle' },
          { attributeDef: 'BRUK2', caption: 'Genre' },
          { attributeDef: 'FLAG', caption: 'Förlag' },
          { attributeDef: 'UTGAVOR', caption: 'Utgåvor' },
          { attributeDef: 'FLAGNR', caption: 'Artikelnummer' },
          { attributeDef: 'UTGIVEN', caption: 'Utgivningsår' },
          { attributeDef: 'COPYRIGHT', caption: 'Copyright' },
          { attributeDef: 'PrefixID', caption: 'PrefixID' },
          { attributeDef: 'SAML', caption: 'Samling' },
        ],
        notImplemented('ExportDBToXML DetailComp')
      )
    ),
  },
};

export default MURutiner;
